import { createApiClient } from "Network/ApiClient";

export const VipAxiosInstance = createApiClient("Vip/");
